import convertCoords from "./convertCoords";

export default function parseData(data) {
    convertCoords(" 40°30′N")

}